import styled from 'styled-components'
import { Flex, Column } from '../../../../styles/styledGlobal'

export const ModalBody = styled(Column)`
width: 37rem;
padding-bottom: 1rem;
padding-top: 2rem;
justify-content: center;
align-items:center;
h2{
    color:var(--v4);
    line-height: 2.5rem;
}

span{
    color: var(--a4);
    font-weight: bold;
    margin-top: .5rem;
}
`

export const ModalHeader = styled(Flex)`
align-items:center;
justify-content: space-between;
border-bottom: 0.063rem solid var(--c4);
padding: 1rem;

h2{
    color:var(--a3);
    font-size: 1.5rem;
}

svg{
    color:var(--a2);
    cursor:pointer;
}
`

export const ModalFooter = styled(Flex)`
justify-content: center;
padding: 1rem 0rem;
`
